import { createElement, FC, PropsWithChildren } from 'react';
import { StarIcon } from '@heroicons/react/24/solid';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { cn } from '@/utils/classNames.ts';

type Props = {
  icon?: FC<any>;
};

const IconListElement: FC<PropsWithClassName<PropsWithChildren<Props>>> = ({ children, className, icon }) => (
  <div className={cn('flex gap-2 items-start', className)}>
    {icon ? (
      createElement(icon, { className: 'w-4 h-4 text-primary mt-0.5 shrink-0' })
    ) : (
      <StarIcon className="w-4 h-4 text-primary mt-0.5 shrink-0" />
    )}
    <p className="text-base-content">{children}</p>
  </div>
);

export default IconListElement;
